import { render, staticRenderFns } from "./ProductoMonto.vue?vue&type=template&id=a63245ac&"
import script from "./ProductoMonto.vue?vue&type=script&lang=js&"
export * from "./ProductoMonto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports